import { Link } from "react-router-dom";

const browseLinks = [
  { label: "电影专区", to: "/category/movie" },
  { label: "电视剧专区", to: "/category/tv" },
  { label: "综艺专区", to: "/category/variety" },
  { label: "影视搜索", to: "/search" },
];

const aboutLinks = [
  { label: "关于我们", to: "/about" },
  { label: "服务说明", to: "/about" },
  { label: "联系方式", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="w-full px-4 pb-8 pt-12 md:px-8 md:pt-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50/15 text-background-50">
                <i className="ri-play-fill text-lg leading-none" />
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">
                蜜桃<span className="text-accent-300">33</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80">
              蜜桃33 是一个综合影视资源展示与介绍平台，整理电影、电视剧与综艺的剧情简介、主创信息与相关推荐，帮助影视爱好者快速找到今晚想看的那一部。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-background-300/60">
              本站为演示性质的前端展示项目，片名、海报、主创与评分均为虚构示例，不提供真实播放服务。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">浏览内容</h3>
            <ul className="mt-4 space-y-2.5">
              {browseLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200/75 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50">关于站点</h3>
            <ul className="mt-4 space-y-2.5">
              {aboutLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200/75 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="mailto:hello@mitao33.demo"
                  className="text-sm text-background-200/75 transition-colors hover:text-accent-300"
                >
                  hello@mitao33.demo
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-300/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 蜜桃33 影视资源展示平台 · 演示版本</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>内容均为虚构示例</span>
            <span className="hidden sm:inline">·</span>
            <span>不提供真实播放</span>
          </p>
        </div>
      </div>
    </footer>
  );
}